export default __webpack_public_path__ + "static/media/MallEvent_09.004db76f.png";